import { Container } from "@mui/material";
import { OffersListWidgetLazy } from "../../widgets/OffersListWidget/OffersListWidgetLazy";

export function ContentRendererOffersList({ bannersSearch, ...block }: any) {
  const params = new URLSearchParams(block.filterLink || "");
  let cityId: number | undefined = undefined;
  if (params.get("cityId") && !Number.isNaN(Number(params.get("cityId")))) {
    cityId = Number(params.get("cityId"));
  }
  const hasDates = !!params.get("arrivalDate") && !!params.get("departureDate");

  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <OffersListWidgetLazy
        bannersSearch={bannersSearch}
        bannerBlockId="landingPage"
        withAttributesContext
        cityIdContext={cityId}
        hotelIdContext={params.get("hotelId") || undefined}
        perPage={4}
        dataTestId="offers-list"
        showTotalPrice
        infinite
        type={hasDates ? undefined : "future"}
      />
    </Container>
  );
}
